import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	moreIncidents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lessIncidents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moreIncidents: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.more-incidents',
		defaultMessage:
			'+ {incidentCount} more {incidentCount, plural, one {incident} other {incidents}}',
		description: 'Button to show more incidents',
	},
	lessIncidents: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.less-incidents',
		defaultMessage: 'Show less',
		description: 'Button to show less incidents',
	},
});
export default messages;
